import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { useTheme } from '@material-ui/core/styles';
import { Fab } from '@material-ui/core';
import { ButtonAnimate } from '../animate/others/ButtonAnimate';
export const MFab = forwardRef(({ color = 'primary', children, sx, ...other }, ref) => {
    const theme = useTheme();
    if (color === 'default' || color === 'inherit' || color === 'primary' || color === 'secondary') {
        return (_jsx(ButtonAnimate, { children: _jsx(Fab, Object.assign({ ref: ref, color: color, sx: sx }, other, { children: children }), void 0) }, void 0));
    }
    return (_jsx(ButtonAnimate, { children: _jsx(Fab, Object.assign({ ref: ref, sx: {
                color: theme.palette[color].contrastText,
                bgcolor: theme.palette[color].main,
                '&:hover': {
                    bgcolor: theme.palette[color].dark,
                },
                ...sx,
            } }, other, { children: children }), void 0) }, void 0));
});
//# sourceMappingURL=MFab.js.map